/*
 * PDP gallery. The sliding is done by CSS scroll-snap (see .pr-gallery__track
 * in pure-rose-pdp.css), so this only wires the controls to scroll position --
 * no carousel library, and swipe/momentum come from the browser.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pr-pdp__media, .pr-pdp .product__media-wrapper').forEach(function (root) {
    const main = root.querySelector('[data-pr-main-carousel]');
    const track = main && main.querySelector('[data-pr-gallery-track]');
    if (!track || track.dataset.prGalleryReady === '1') return;
    track.dataset.prGalleryReady = '1';

    const slides = Array.prototype.slice.call(track.querySelectorAll('.pr-gallery__slide'));
    if (!slides.length) return;

    const thumbsRoot = root.querySelector('[data-pr-thumb-carousel]');
    const thumbsTrack = thumbsRoot && thumbsRoot.querySelector('[data-pr-thumbs-track]');
    const thumbs = thumbsTrack
      ? Array.prototype.slice.call(thumbsTrack.querySelectorAll('.pr-gallery__thumb'))
      : [];

    // Dots: mobile only in CSS, but built whenever there is more than one slide.
    let dots = [];
    if (slides.length > 1) {
      const wrap = document.createElement('div');
      wrap.className = 'pr-gallery__dots';
      slides.forEach(function (_, i) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pr-gallery__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        wrap.appendChild(dot);
      });
      main.insertAdjacentElement('afterend', wrap);
      dots = Array.prototype.slice.call(wrap.querySelectorAll('.pr-gallery__dot'));
    }

    function currentIndex() {
      // offsetLeft rather than index * width: robust to gaps and odd widths.
      const x = track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach(function (slide, i) {
        const dist = Math.abs(slide.offsetLeft - track.offsetLeft - x);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    function goTo(i) {
      const target = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    // Every slide is square, so this pins the track to that one height rather
    // than letting it collapse before the images have resolved.
    function syncHeight(i) {
      const slide = slides[i];
      if (slide && slide.offsetHeight) track.style.height = slide.offsetHeight + 'px';
    }

    function setActive(i) {
      syncHeight(i);
      dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (thumb, n) { thumb.classList.toggle('is-active', n === i); });
      if (thumbs[i] && thumbsTrack) {
        const t = thumbs[i];
        const left = t.offsetLeft - thumbsTrack.offsetLeft;
        const visible = left >= thumbsTrack.scrollLeft &&
          left + t.offsetWidth <= thumbsTrack.scrollLeft + thumbsTrack.clientWidth;
        if (!visible) {
          thumbsTrack.scrollTo({ left: left - (thumbsTrack.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    let ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        setActive(currentIndex());
      });
    }, { passive: true });

    // Arrows wrap, matching the rewind behaviour the previous carousel had.
    const prev = main.querySelector('[data-pr-gallery-prev]');
    const next = main.querySelector('[data-pr-gallery-next]');
    if (prev) prev.addEventListener('click', function () {
      const i = currentIndex();
      goTo(i <= 0 ? slides.length - 1 : i - 1);
    });
    if (next) next.addEventListener('click', function () {
      const i = currentIndex();
      goTo(i >= slides.length - 1 ? 0 : i + 1);
    });

    thumbs.forEach(function (thumb, i) {
      const btn = thumb.querySelector('[data-pr-thumb]') || thumb;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(i);
      });
    });

    if (thumbsTrack) {
      const step = function () { return Math.max(thumbsTrack.clientWidth * 0.8, 80); };
      const tPrev = thumbsRoot.querySelector('[data-pr-thumbs-prev]');
      const tNext = thumbsRoot.querySelector('[data-pr-thumbs-next]');
      if (tPrev) tPrev.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (tNext) tNext.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    setActive(0);
    // Ratios are known from CSS, but offsetHeight is not until layout settles.
    window.addEventListener('load', function () { syncHeight(currentIndex()); });
    window.addEventListener('resize', function () { syncHeight(currentIndex()); });
  });
});
